import React, { createContext, useState, useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("ko"); // 기본 언어는 한국어
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith("/en/")) {
      setLanguage("en");
    } else if (!path.startsWith("/en/") && language === "en") {
      setLanguage("ko");
    }
  }, [location.pathname]);

  const changeLanguage = (lang) => {
    const currentPath = location.pathname;

    if (lang === "en" && !currentPath.startsWith("/en/")) {
      const newPath = currentPath === "/" ? "/en/" : `/en${currentPath}`;
      navigate(newPath);
    } else if (lang === "ko" && currentPath.startsWith("/en/")) {
      const newPath = currentPath === "/en/" ? "/" : currentPath.replace("/en", "");
      navigate(newPath);
    }
    setLanguage(lang);
  };

  return <LanguageContext.Provider value={{ language, changeLanguage }}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
